function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "No entry exit");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "No-entry-exit",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "No-entry/exit"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#D8D8D8",
  opacity: 0,
  x: 0,
  y: 0,
  width: 28,
  height: 28
}), /*#__PURE__*/React.createElement("path", {
  d: "M14,0 C21.7319865,0 28,6.2680135 28,14 C28,21.7319865 21.7319865,28 14,28 C6.2680135,28 0,21.7319865 0,14 C0,6.2680135 6.2680135,0 14,0 Z M14,5 C9.02943725,5 5,9.02943725 5,14 C5,18.9705627 9.02943725,23 14,23 C18.9705627,23 23,18.9705627 23,14 C23,9.02943725 18.9705627,5 14,5 Z M19.1862778,10.9810145 C19.7036068,11.8678116 20,12.8992926 20,14 C20,17.3137085 17.3137085,20 14,20 C12.8992926,20 11.8678116,19.7036068 10.9810145,19.1862778 L10.9810145,19.1862778 Z M14,8 C15.124294,8 16.1763629,8.3092319 17.0757939,8.84728263 L17.0757939,8.84728263 L8.84728263,17.0757939 C8.3092319,16.1763629 8,15.124294 8,14 C8,10.6862915 10.6862915,8 14,8 Z",
  id: "Combined-Shape",
  fill: "#FF3C2B"
})));

var SvgNoEntryExit = function SvgNoEntryExit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "29px",
    viewBox: "0 0 28 29",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoEntryExit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no_entry_exit.e8a7b6ec.svg";
export { ForwardRef as ReactComponent };